export default {"src":"https://fishbrain.com/_next/static/media/ic_weather_day_311.c1a681aa.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};